import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors } from '../../../constants'

const Center = styled.div`
    margin: 0 auto;
`

const Wrapper = styled.div`
    background: ${colors.bluedarkest};
    color: ${colors.white};
    cursor: pointer;
    display: flex;
    padding: 10px 30px;
    text-align: center;
    width: 100%;

    &:active,
    &:focus,
    &:hover {
        background: ${colors.white};
        color: ${colors.bluedarkest};
    }
`

const NextPageComponent = ({ children, onClick, innerRef }) => {
    return (
        <Wrapper ref={innerRef} onClick={onClick}>
            <Center>{children}</Center>
        </Wrapper>
    )
}

NextPageComponent.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    innerRef: PropTypes.shape({}),
}

NextPageComponent.defaultProps = {
    children: '',
    onClick: () => null,
    innerRef: null,
}

export default React.forwardRef((props, ref) => <NextPageComponent innerRef={ref} {...props} />)
